import BoggleGuideSignupPage from './components/boggler-guide-signup-page';
import './index.css';
export default function App() {
  const handleApply = async (formData) => {
    // Wire this up to your own API endpoint
    console.log('Application submitted:', formData);
    // Example:
    // await fetch('/api/apply', {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json' },
    //   body: JSON.stringify(formData),
    // });
  };

  return <BoggleGuideSignupPage onApply={handleApply} />;
}
